// 入仓登记 입력 보호(2026-11-01 崔凡 — 位置号 乱码·扫码太灵敏) — 순수 함수라 화면 없이 시험한다(code-vue/tests/inbound-scan-guard_test.mjs).
// 모바일(MobileInboundRegister)·PC(logisInboundRegisterV0) 공용.

// 서버 LOCATION_CODE_RE 와 같다(库位号 형식)
export const LOCATION_RE = /^[A-Za-z0-9][A-Za-z0-9_.-]{0,29}$/;
// 단계가 바뀐 직후 이 시간 안에 들어온 스캔은 받지 않는다(앞 단계 스캔의 꼬리·연타가 다음 칸으로 새는 것 방지)
export const STEP_LOCK_MS = 700;
// 위치번호가 인식된 뒤 자동 入仓까지 기다리는 시간 — 틀렸으면 이 안에 「重扫位置号」로 고친다
export const AUTOSAVE_DELAY_MS = 1500;
// 숫자만 이 길이 이상이면 위치번호가 아니라 택배 송장·상품 바코드(오인식)로 본다
const BARCODE_LIKE_DIGITS = 8;

// 위치번호 검사 — { ok, value(대문자), reason } reason: empty | format | waybill | barcodeLike
export function checkLocation(raw, waybill) {
  const value = String(raw === undefined || raw === null ? '' : raw).trim().toUpperCase();
  if (!value) return { ok: false, value, reason: 'empty' };
  if (!LOCATION_RE.test(value)) return { ok: false, value, reason: 'format' };
  if (waybill && value === String(waybill).trim().toUpperCase()) return { ok: false, value, reason: 'waybill' };
  if (new RegExp('\\d{' + BARCODE_LIKE_DIGITS + ',}').test(value)) return { ok: false, value, reason: 'barcodeLike' };
  return { ok: true, value, reason: '' };
}

// 거절 사유 → 화면 문구(중국어 + 한국어, 이 화면 스타일)
export function locationRejectText(reason, raw) {
  const v = String(raw || '').slice(0, 30);
  if (reason === 'waybill') return '这是快递单号，请扫库位号(운송장입니다. 위치번호를 스캔하세요)';
  if (reason === 'barcodeLike') return '不是位置号，已清空: ' + v + ' — 请重新扫描或手动输入 例 A-01-01(위치번호가 아니라 비운 뒤 다시 입력)';
  return '位置号格式错误，已清空: ' + v + ' — 请重新输入 例 A-01-01(위치번호 형식 오류, 비웠습니다)';
}

export function isStepLocked(now, lockedUntil) {
  return now < lockedUntil;
}
